/**
 * TanStack Query keys for search
 */
export const searchKeys = {
  all: ["search"] as const,
  products: (query: string, locale: string) =>
    [...searchKeys.all, "products", query, locale] as const,
};
